import {GET_ALL_TAGS_BY_ACCOUNTIDS} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
import _ from 'lodash';

export default function glAccountAssociatedTagsReducer(state = initialstate.engagementTagByAccountIds, action) {
	switch (action.type) {
		case GET_ALL_TAGS_BY_ACCOUNTIDS:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;

		default:
			return state;
	}
}
